import React from "react";
import Toggle from "../../../../Forms/Toggle";
import { Text } from "@fluentui/react";
import ClientDropdown from "./Forms/ClientDropdown";
import CobrandTagsDropdown from "./Forms/CobrandTagsDropdown";
import CobrandDropDown from "./Forms/CobrandDropDown";
import { useFormikContext } from "formik";

const OnOffSettingsFields = ({setOptionTable}) => {
  const { getFieldProps } = useFormikContext();
  const isGlobalOn = getFieldProps("globalOn").value;

  return (
    <>
      <Toggle
        name="globalOn"
        label="Audio Global Setting"
        onText="Audio is on for all"
        offText="Audio is off for all"
      />
      <Text variant="small">
        If the audio is {isGlobalOn ? "on" : "off"} globally, then you can
        set the exceptions below.
      </Text>
      <ClientDropdown
        name={"client"}
        label={`${isGlobalOn ? "OFF" : "ON"} for Clients`}
        multiSelect
        setOptionTable={setOptionTable}
      />
      <CobrandTagsDropdown
        name="cobrandTag"
        label={`${isGlobalOn ? "OFF" : "ON"} for Cobrand Tags`}
        setOptionTable={setOptionTable}
        multiSelect
      />
      <CobrandDropDown
        name={"cobrand"}
        label={`${isGlobalOn ? "OFF" : "ON"} for Cobrand`}
        byNameOrId="id"
        setOptionTable={setOptionTable}
        multiSelect
      />
    </>
  );
};

export default OnOffSettingsFields;
